module.exports = __webpack_public_path__ + "img/map_yun_left.cad3b55b.png";